import type { ProductListItem } from '../../lib/site';

/**
 * 카드·줄이 걸어 줄 상세 주소.
 *
 * **교재는 언제나 `/books`** 다 — 목록의 기본 주소(`base`)가 `/lectures` 여도 그렇다.
 * 첫 화면 섹션·프로모션처럼 강좌와 교재가 **섞여 담기는 자리**가 있어서, 자리마다
 * 따로 계산하면 교재를 눌렀을 때 강좌 상세로 가는 사고가 난다(예전 `ProductGrid`(폐기) 가
 * `/lectures/{id}` 로 못 박아 그랬다).
 *
 * `'use client'` 를 붙이지 않는다 — 첫 화면(서버 컴포넌트)에서도 부르기 때문이다.
 */
export function productHref(base: string, p: { id: number; type: ProductListItem['type'] }): string {
  return p.type === 'BOOK' ? `/books/${p.id}` : `${base}/${p.id}`;
}
